import { ShakaPlayer } from './ShakaPlayer';

export default ShakaPlayer;



// WEBPACK FOOTER //
// ./src/components/ShakaPlayer/index.js